// @ts-ignore
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  TooltipContainer,
  TooltipTrigger,
  TooltipContent,
  TooltipArrow,
  TooltipText,
} from './styles';

type TooltipInfoProps = {
  icon: React.ReactNode;
  textTooltip: string;
  routeType?: boolean;
  isAutomatic?: boolean;
};

const TooltipInfo: React.FC<TooltipInfoProps> = ({
  icon,
  textTooltip,
  routeType,
  isAutomatic,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipTriggerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent): void => {
    if (
      tooltipTriggerRef.current &&
      !tooltipTriggerRef.current.contains(event.target as Node)
    ) {
      setIsVisible(false);
    }
  };

  const toggleTooltip = (): void => {
    if (!isVisible && tooltipTriggerRef.current) {
      let positionCalc = 75;
      if (routeType) {
        positionCalc = 28;
      } else if (isAutomatic) {
        positionCalc = 40;
      }
      const rect = tooltipTriggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY + positionCalc, // Position tooltip above the icon with 12px gap
        left: rect.left + window.scrollX + rect.width / 2,
      });
    }
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <>
      <TooltipContainer ref={tooltipTriggerRef}>
        <TooltipTrigger onClick={toggleTooltip}>{icon}</TooltipTrigger>
      </TooltipContainer>
      {isVisible &&
        createPortal(
          <TooltipContent
            style={{ top: `${position.top}px`, left: `${position.left}px` }}
          >
            <TooltipArrow />
            <TooltipText>{textTooltip}</TooltipText>
          </TooltipContent>,
          document.body // Coloca o tooltip no nível superior da árvore do DOM
        )}
    </>
  );
};

TooltipInfo.defaultProps = {
  routeType: false,
  isAutomatic: false,
};

export default TooltipInfo;
